export function getConfirmConfigurationOption(key) {
  const options = {
    'confirm-button-title-max-length': 20,
    'confirm-text-max-length': 240
  };
  if (options[key] != undefined) {
    return options[key];
  }
  return null;
}
